import React, { Component } from 'react';
import moment from 'moment';
import { BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Bar, ResponsiveContainer } from 'recharts';
import { Row, Col, Alert, Card, CardText, CardBody, CardTitle, Progress, UncontrolledTooltip } from 'reactstrap';

import './styles.css';
import Modal from '../Escrituras/Modal';
import ModalEnvioMails from './ModalEnvioMails.js';
import NumericFilter from "../../../components/ParadigmaTable/NumericFilter";
import ParadigmaAsyncSeeker from '../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker';
import ParadigmaDatePicker from '../../../components/ParadigmaDatePicker/ParadigmaDatePicker';
import ParadigmaLabeledInput from '../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput';
import ParadigmaTable from '../../../components/ParadigmaTable/ParadigmaTable.js';
import api from '../../../api/api';
import functions from '../../../api/functions';
import { format } from '../../../functions/functions';

class EstadoGralDeudas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filtros: {
                desde: moment().startOf('month').subtract(2, 'year'),
                hasta: moment().endOf('month'),
                loteo_id: null,
                loteo_nombre:'',
                con_interes:false,
            },
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "loteo_id",
                    id: "loteo_id",
                    accessor: "loteo_id",
                    lookup: "exact",
                    show: false,
                    private: true,
                },
                {
                    Header: "Fecha",
                    id: "fecha",
                    accessor: d => moment(d.fecha).format('DD/MM/YYYY'),
                    className: "text-center",
                    show: true,
                    lookup:'range',
                    filterable:false,
                    width: 100,
                    exportWidth: "110",
                },
                {
                    Header: "Comprador/es",
                    id: "clientes",
                    accessor: d => d.clientes,
                    show: true,
                    exportWidth: "200",
                },
                {
                    Header: "Loteo",
                    id: "loteo",
                    lookup: "nombre__icontains",
                    accessor: d => d.loteo.nombre,
                    show: true,
                    exportWidth: "150",
                },
                {
                    Header: "Lote",
                    id: "lote_nombre",
                    accessor: "lote_nombre",
                    show: true,
                    exportWidth: "100",
                },
                {
                    Header: "Cuotas Restantes",
                    id: "cuotasImpagas",
                    accessor: "cuotasImpagas",
                    className: 'text-center',
                    show: true,
                    exportWidth: "100",
                },
                {
                    Header: "Vencidas",
                    id: "cuotasVencidas",
                    accessor: "cuotasVencidas",
                    className: 'text-center',
                    show: true,
                    exportWidth: "100",
                },
                {
                    Header: "No Vencidas",
                    id: "cuotasNoVencidas",
                    accessor: "cuotasNoVencidas",
                    className: 'text-center',
                    show: true,
                    exportWidth: "100",
                },
                {
                    Header: "Moneda",
                    id: "moneda",
                    accessor: "moneda",
                    show: false,
                    private: true,
                },
                {
                    Header: "Por Saldar",
                    id: "montoAdeudaSinInteres",
                    accessor: d => `${d.moneda.simbolo} ${format(d.montoAdeudaSinInteres)}`,
                    className: 'text-right',
                    show: true,
                    filterable:false,
                    sortable:false,
                    Filter: ({ filter, onChange }) => <NumericFilter filter={filter} onChange={onChange} />,
                    exportWidth: "150",
                    exportCurrency: true,
                },
                {
                    Header: "Con Interes",
                    id: "montoAdeudaConInteres",
                    accessor: d => `${d.moneda.simbolo} ${format(d.montoAdeudaConInteres)}`,
                    className: 'text-right',
                    show: true,
                    filterable:false,
                    sortable:false,
                    Filter: ({ filter, onChange }) => <NumericFilter filter={filter} onChange={onChange} />,
                    exportWidth: "150",
                    exportCurrency: true,
                }
            ],
        };
    }

    componentDidMount() {
        this.fetch();
    }

    fetch = () => {
        const { desde, hasta, loteo_id, con_interes } = this.state.filtros;

        let filters = [];
        if (desde) filters.push(`from=${desde.format('YYYY-MM-DD')}`);
        if (hasta) filters.push(`to=${hasta.format('YYYY-MM-DD')}`);
        if (loteo_id) filters.push(`loteo=${loteo_id}`);
        filters.push(`con_interes=${con_interes ? "True" : "False"}`);

        functions.get(api.escrituras.deudasReportes, null, null, { filters }, resp => {
            this.setState({
                totalDeudaACobrar: resp.data.totalDeudaACobrar,
                totalDeudaACobrarDolares: resp.data.totalDeudaACobrarDolares,
            });
        })
    }

    parseDate = (month, year) => {
        return moment(`${month} ${year}`, "MM YYYY").format('MMM YY');
    }

    render() {
        const { desde, hasta, loteo_id, loteo_nombre, con_interes } = this.state.filtros;
        const { totalDeudaACobrar, totalDeudaACobrarDolares, columns } = this.state;

        const onChangeFilter = (field,value)=>{
            this.setState(prevState=>{
                let filtros = prevState.filtros;
                filtros[field] = value;
                prevState.filtros = filtros;
                return prevState;
            }, this.fetch);
        }

        let detalle = [];
        let outerFilter = [];

        if (totalDeudaACobrar && totalDeudaACobrar.detalle){
            totalDeudaACobrar.detalle.forEach((item, i) => {
                detalle.push({
                    Mes:item.Mes,
                    TotalVencidos: `$ ${format(item.TotalVencidos.toFixed(2))}`,
                    TotalNoVencidos: `$ ${format(item.TotalNoVencidos.toFixed(2))}`,
                    CantidadNoVencidos: item.CantidadNoVencidos,
                    CantidadVencidos: item.CantidadVencidos,
                });
            });
        }

        if (totalDeudaACobrarDolares && totalDeudaACobrarDolares.detalle){
            totalDeudaACobrarDolares.detalle.forEach((item, i) => {
                detalle.push({
                    Mes:item.Mes,
                    TotalVencidos: `$ ${format(item.TotalVencidos.toFixed(2))}`,
                    TotalNoVencidos: `$ ${format(item.TotalNoVencidos.toFixed(2))}`,
                    CantidadNoVencidos: item.CantidadNoVencidos,
                    CantidadVencidos: item.CantidadVencidos,
                });
            });
        }

        if (loteo_id) {
            outerFilter.push({
                id: 'loteo_id',
                lookup:'exact',
                value: loteo_id
            });
        }
        if (desde && hasta) {
            outerFilter.push({
                id: 'fecha',
                lookup:'range',
                value: `${moment(desde).format('YYYY-MM-DD')},${moment(hasta).format('YYYY-MM-DD')}`
            });
        }

        return (
            <div className="deudasContainer p-3">
                <Row className="mb-2">
                    <Col className="col-12">
                        <Card body className="border-0 p-0 m-0">
                            <CardTitle className="text-center py-2 mb-0 col-color">Filtros</CardTitle>
                            <CardBody>
                                <Row>
                                    <Col className="col-12 col-md-4">
                                        <ParadigmaLabeledInput
                                            label="Período"
                                            md={[3, 9]}
                                            inputComponent={
                                                <Row>
                                                    <Col className="col-6 col-md-12 col-lg-12 col-xl-6 mb-0 mb-md-1 mb-xl-0 pr-1">
                                                        <ParadigmaDatePicker fieldName={"fechaInicio"}
                                                            datetime={false}
                                                            placeholder={"Desde"}
                                                            icon={"fa fa-calendar"}
                                                            value={this.state.filtros.desde}
                                                            onChange={data => this.setState(prevState => ({
                                                                filtros: {
                                                                    ...prevState.filtros,
                                                                    desde: data
                                                                }
                                                            }), this.fetch)}
                                                        />
                                                    </Col>
                                                    <Col className="col-6 col-md-12 col-lg-12 col-xl-6 pl-1">
                                                        <ParadigmaDatePicker fieldName={"fechaFin"}
                                                            datetime={false}
                                                            placeholder={"Hasta"}
                                                            icon={"fa fa-calendar"}
                                                            value={this.state.filtros.hasta}
                                                            onChange={data => this.setState(prevState => ({
                                                                filtros: {
                                                                    ...prevState.filtros,
                                                                    hasta: data
                                                                }
                                                            }), this.fetch)}
                                                        />
                                                    </Col>
                                                </Row>
                                            }
                                        />
                                    </Col>
                                    <Col className="col-12 col-md-4">
                                        <ParadigmaLabeledInput
                                            label="Loteos"
                                            md={[3, 9]}
                                            inputComponent={
                                                <ParadigmaAsyncSeeker
                                                    url={api.loteos.loteos}
                                                    value={this.state.filtros.loteo_id}
                                                    parameters={{
                                                        paginationEnabled:false,
                                                        sort:['nombre'],
                                                    }}
                                                    onChange={data => this.setState(prevState => ({
                                                        filtros: {
                                                            ...prevState.filtros,
                                                            loteo_id: data ? data.id : null,
                                                            loteo_nombre: data ? data.nombre : '',
                                                        }
                                                    }), this.fetch)}
                                                />
                                            }
                                        />
                                    </Col>
                                    <Col className="col-12 col-md-4 my-auto">
                                        <div className="custom-control custom-switch text-left my-auto control-switch-interes">
                                            <input type="checkbox" className="custom-control-input" id="customSwitchAplicarInteres" checked={con_interes}/>
                                            <label className="custom-control-label" htmlFor="customSwitchAplicarInteres" onClick={(evt) => onChangeFilter('con_interes',!con_interes)}>Aplicar Interes al Monto de Cuota</label>
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Card>
                            {
                                totalDeudaACobrar &&
                                    <CardBody>
                                        <CardTitle className="text-center">Estado de Cobranzas del {moment(desde).format('DD-MM-YYYY')} al {moment(hasta).format('DD-MM-YYYY')}{loteo_nombre != '' ? ` en Loteo ${loteo_nombre}` : ""} en Pesos</CardTitle>
                                        {
                                            totalDeudaACobrar.noVencidasPorc == 0 && totalDeudaACobrar.vencidasPorc == 0 ?
                                                <Alert color="info">No hay cobranzas pendientes.</Alert>
                                                :
                                                <React.Fragment>
                                                    <CardText>
                                                        <Progress multi className="deudasprogressbar">
                                                            <Progress bar color="info" value={`${totalDeudaACobrar.noVencidasPorc.toFixed(2)}`}><div className="" id="UncontrolledTooltipNoVencidos"><i class="fa fa-check-circle-o pt-1" aria-hidden="true"></i></div></Progress>
                                                            <Progress bar color="danger" value={`${totalDeudaACobrar.vencidasPorc.toFixed(2)}`}><div className="" id="UncontrolledTooltipVencidos"><i class="fa fa-exclamation-triangle pt-1" aria-hidden="true"></i></div></Progress>
                                                        </Progress>
                                                        <UncontrolledTooltip placement="bottom" target="UncontrolledTooltipNoVencidos">
                                                            No Vencidas - $ {format(totalDeudaACobrar.noVencidasMonto.toFixed(2))}
                                                        </UncontrolledTooltip>
                                                        <UncontrolledTooltip placement="bottom" target="UncontrolledTooltipVencidos">
                                                            Vencidas - $ {format(totalDeudaACobrar.vencidasMonto.toFixed(2))}
                                                        </UncontrolledTooltip>
                                                        <p className="text-center m-0">No Vencidas - $ {format(totalDeudaACobrar.noVencidasMonto.toFixed(2))}</p>
                                                        <p className="text-center m-0">Vencidas - $ {format(totalDeudaACobrar.vencidasMonto.toFixed(2))}</p>
                                                        <p className="text-center m-0">Total - ${format(totalDeudaACobrar.total.toFixed(2))}</p>
                                                        {
                                                            detalle.length>0 &&
                                                                <Card body className="border-0 p-0 mb-3">
                                                                    <CardTitle className="text-center py-2 col-color">Resumen de Cuotas por Mes</CardTitle>
                                                                    <CardBody>
                                                                        <ResponsiveContainer width={'100%'} height={250}>
                                                                            <BarChart data={totalDeudaACobrar.detalle}>
                                                                                <CartesianGrid strokeDasharray="3 3" />
                                                                                <XAxis dataKey="Mes" />
                                                                                <YAxis />
                                                                                <Tooltip formatter={value => format(value)} />
                                                                                <Legend />
                                                                                <Bar name="Total Vencidos ($)" dataKey="TotalVencidos" stackId="Mes" fill="#f86c6b" />
                                                                                <Bar name="Cantidad Vencidos" dataKey="CantidadVencidos" stackId="Mes" fill="#f86c6b" />
                                                                                <Bar name="Total No Vencidos ($)" dataKey="TotalNoVencidos" stackId="Mes" fill="#63c2de" />
                                                                                <Bar name="Cantidad No Vencidos" dataKey="CantidadNoVencidos" stackId="Mes" fill="#63c2de" />
                                                                            </BarChart>
                                                                        </ResponsiveContainer>
                                                                    </CardBody>
                                                                </Card>
                                                        }
                                                    </CardText>
                                                </React.Fragment>
                                        }
                                    </CardBody>
                            }
                        </Card>
                        <Card>
                            {
                                totalDeudaACobrarDolares &&
                                    <CardBody>
                                        <CardTitle className="text-center">Estado de Cobranzas del {moment(desde).format('DD-MM-YYYY')} al {moment(hasta).format('DD-MM-YYYY')}{loteo_nombre != '' ? ` en Loteo ${loteo_nombre}` : ""} en Dolares</CardTitle>
                                        {
                                            totalDeudaACobrarDolares.noVencidasPorc == 0 && totalDeudaACobrarDolares.vencidasPorc == 0 ?
                                                <Alert color="info">No hay cobranzas pendientes.</Alert>
                                                :
                                                <React.Fragment>
                                                    <CardText>
                                                        <Progress multi className="deudasprogressbar">
                                                            <Progress bar color="info" value={`${totalDeudaACobrarDolares.noVencidasPorc.toFixed(2)}`}><div className="" id="UncontrolledTooltipNoVencidos"><i class="fa fa-check-circle-o pt-1" aria-hidden="true"></i></div></Progress>
                                                            <Progress bar color="danger" value={`${totalDeudaACobrarDolares.vencidasPorc.toFixed(2)}`}><div className="" id="UncontrolledTooltipVencidos"><i class="fa fa-exclamation-triangle pt-1" aria-hidden="true"></i></div></Progress>
                                                        </Progress>
                                                        <UncontrolledTooltip placement="bottom" target="UncontrolledTooltipNoVencidos">
                                                            No Vencidas - $ {format(totalDeudaACobrarDolares.noVencidasMonto.toFixed(2))}
                                                        </UncontrolledTooltip>
                                                        <UncontrolledTooltip placement="bottom" target="UncontrolledTooltipVencidos">
                                                            Vencidas - $ {format(totalDeudaACobrarDolares.vencidasMonto.toFixed(2))}
                                                        </UncontrolledTooltip>
                                                        <p className="text-center m-0">No Vencidas - U$S {format(totalDeudaACobrarDolares.noVencidasMonto.toFixed(2))}</p>
                                                        <p className="text-center m-0">Vencidas - U$S {format(totalDeudaACobrarDolares.vencidasMonto.toFixed(2))}</p>
                                                        <p className="text-center m-0">Total - U$S {format(totalDeudaACobrarDolares.total.toFixed(2))}</p>
                                                        {
                                                            detalle.length>0 &&
                                                                <Card body className="border-0 p-0 mb-3">
                                                                    <CardTitle className="text-center py-2 col-color">Resumen de Cuotas por Mes</CardTitle>
                                                                    <CardBody>
                                                                        <ResponsiveContainer width={'100%'} height={250}>
                                                                            <BarChart data={totalDeudaACobrarDolares.detalle}>
                                                                                <CartesianGrid strokeDasharray="3 3" />
                                                                                <XAxis dataKey="Mes" />
                                                                                <YAxis />
                                                                                <Tooltip formatter={value => format(value)} />
                                                                                <Legend />
                                                                                <Bar name="Total Vencidos (U$S)" dataKey="TotalVencidos" stackId="Mes" fill="#f86c6b" />
                                                                                <Bar name="Cantidad Vencidos" dataKey="CantidadVencidos" stackId="Mes" fill="#f86c6b" />
                                                                                <Bar name="Total No Vencidos (U$S)" dataKey="TotalNoVencidos" stackId="Mes" fill="#63c2de" />
                                                                                <Bar name="Cantidad No Vencidos" dataKey="CantidadNoVencidos" stackId="Mes" fill="#63c2de" />
                                                                            </BarChart>
                                                                        </ResponsiveContainer>
                                                                    </CardBody>
                                                                </Card>
                                                        }
                                                    </CardText>
                                                </React.Fragment>
                                        }
                                    </CardBody>
                            }
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col className="col-12">
                        {
                            totalDeudaACobrar != undefined && totalDeudaACobrar!=null && (totalDeudaACobrar.noVencidasPorc != 0 || totalDeudaACobrar.vencidasPorc != 0) &&
                                <ParadigmaTable
                                    buttons={[
                                        {
                                            edit: true,
                                            component: props => <Modal {...props} action="CUOTAS" activeTab={2} />,
                                            permission: 'ventas_ventas_view',
                                        },
                                        {
                                            edit: true,
                                            component: props => <ModalEnvioMails {...props} filtros={this.state.filtros} />,
                                            permission: 'ventas_ventas_view',
                                        },
                                    ]}
                                    depth={2}
                                    apiUrl={api.escrituras.listDeudasReportes}
                                    columns={columns}
                                    title={"Escrituras con Cuotas a Cobrar"}
                                    outerFilter={[...outerFilter,]}
                                    exportUrl={api.escrituras.listDeudasReportes}
                                />
                        }
                    </Col>
                </Row>
            </div>
        );
    }
}

export default EstadoGralDeudas;



// WEBPACK FOOTER //
// ./src/views/Escrituras/EstadoGral/Deudas.js